module.exports = __webpack_public_path__ + "assets/img/14.f8ef78f9.png";